var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full max-w-lg relative mx-auto py-8 px-4"},[_vm._v(" Resetting... ")])}
var staticRenderFns = []

export { render, staticRenderFns }